import { Component } from '@angular/core';
import { PointOfSaleService } from '../../point-of-sale.service';
import {
  IPointOfSale,
  POINT_OF_SALE_TTL_ES
} from '../../point-of-sale.interface';
import { CrudTemplate } from 'src/app/@amiga-pyme/crud/templates/crud.template';
import { ICrudTemplate } from 'src/app/@amiga-pyme/crud/templates/crud.interface';

@Component({
  selector: 'pg-point-of-sale',
  templateUrl: './point-of-sale.component.html'
})
export class PointOfSaleComponent
  extends CrudTemplate
  implements ICrudTemplate
{
  constructor(private serviceBase: PointOfSaleService) {
    super(POINT_OF_SALE_TTL_ES, serviceBase);
  }

  ngOnInit() {
    this.table.settings = {
      title: POINT_OF_SALE_TTL_ES,
      columns: [
        { header: 'Sucursal', field: 'branchStoreName' },
        { header: 'Código', field: 'code' },
        { header: 'Serie de Comprobante', field: 'seriesOfReceipts' }
      ]
    };
    this.initSubscriptions$();
  }

  initSubscriptions$() {
    this.suscriptionBase$ = this.serviceBase
      .getData$()
      .subscribe((data: IPointOfSale[]) => {
        this.table.data = data;
      });
  }

  ngOnDestroy() {
    this.unsubscribeBase();
  }
}
